import { MenuContent } from "../../../../../../ui/menu/content.js";
import { MenuPopup } from "../../../../../../ui/menu/popup.js";
import { MenuRoot } from "../../../../../../ui/menu/root.js";
import { MenuTrigger } from "../../../../../../ui/menu/trigger.js";
import { PlaybackRateRadioGroupOptions, PlaybackRateRadioGroupRoot } from "../../../../../../ui/playback-rate-radio-group/component.js";
import { ButtonTooltip } from "../../../../shared/components/buttons/button-tooltip.js";
import { PlaybackRateButton } from "../../../../shared/components/buttons/playback-rate-button.js";
import { RadioItem } from "../../../components/menus/radio-item.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "@videojs/utils/style";
//#region src/internal/skins/default-audio/skins/shared/audio/settings-menu.tsx
/** @jsxImportSource react */
function AudioSettingsMenu({ className, ...props } = {}) {
	return /* @__PURE__ */ jsx(MenuRoot, {
		side: "top",
		align: "center",
		boundary: "viewport",
		...props,
		children: /* @__PURE__ */ jsxs(PlaybackRateRadioGroupRoot, { children: [/* @__PURE__ */ jsx(ButtonTooltip, {
			boundary: "viewport",
			side: "top",
			children: /* @__PURE__ */ jsx(MenuTrigger, {
				render: /* @__PURE__ */ jsx(PlaybackRateButton, {}),
				className
			})
		}), /* @__PURE__ */ jsx(MenuPopup, {
			className: cn("media-popup", "media-popup-surface", "media-menu-popup", "audio-settings-menu-popup"),
			children: /* @__PURE__ */ jsx(MenuContent, {
				className: "media-menu-content",
				children: /* @__PURE__ */ jsx(PlaybackRateRadioGroupOptions, {
					className: "media-menu-radio-group",
					renderItem: (props, item) => /* @__PURE__ */ jsx(RadioItem, {
						...props,
						children: /* @__PURE__ */ jsx("span", { children: item.label })
					})
				})
			})
		})] })
	});
}
//#endregion
export { AudioSettingsMenu };

//# sourceMappingURL=settings-menu.js.map